var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._v("\n  SHORTCUT PAGE\n  "),
      _c("hr"),
      _vm._v(" "),
      _c(
        "b-form-group",
        { class: { "error-input": _vm.$v.data_shortcut.title.$error } },
        [
          _c("label", [_vm._v(" Title ")]),
          _vm._v(" "),
          _c("j-input", {
            attrs: { "max-length": 255, placeholder: "Title" },
            model: {
              value: _vm.$v.data_shortcut.title.$model,
              callback: function($$v) {
                _vm.$set(_vm.$v.data_shortcut.title, "$model", $$v)
              },
              expression: "$v.data_shortcut.title.$model"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "widget-box-configuration",
          class: { "border-danger": _vm.$v.data_shortcut.view_style.$error }
        },
        [
          _c("div", { staticClass: "widget-box-configuration_title" }, [
            _vm._v("View style options")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "widget-box-configuration_desc" }, [
            _vm._v("Options for style list of shortcut")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "d-flex" }, [
            _c(
              "div",
              {
                staticClass: "widget-box-configuration_item-style-options",
                class: {
                  "item-style-options-active":
                    _vm.data_shortcut.view_style === "list"
                },
                on: {
                  click: function($event) {
                    _vm.data_shortcut.view_style = "list"
                  }
                }
              },
              [
                _c("img", {
                  attrs: {
                    src: _vm.iconViewStyleList,
                    width: "10",
                    height: "10"
                  }
                }),
                _vm._v("\n        List\n      ")
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "widget-box-configuration_item-style-options",
                class: {
                  "item-style-options-active":
                    _vm.data_shortcut.view_style === "grid"
                },
                on: {
                  click: function($event) {
                    _vm.data_shortcut.view_style = "grid"
                  }
                }
              },
              [
                _c("img", {
                  attrs: {
                    src: _vm.iconViewStyleGrid,
                    width: "10",
                    height: "10"
                  }
                }),
                _vm._v("\n        Grid\n      ")
              ]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "widget-box-configuration",
          class: { "border-danger": _vm.$v.data_shortcut.shortcut.$error }
        },
        [
          _c("div", { staticClass: "widget-box-configuration_title" }, [
            _vm._v("Shortcuts")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "widget-box-configuration_desc" }, [
            _vm._v("List of shortcut")
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "d-flex flex-wrap",
              class: { "flex-column": _vm.data_shortcut.view_style === "list" }
            },
            [
              _vm._l(_vm.data_shortcut.shortcut, function(val, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    class:
                      "" +
                      (_vm.data_shortcut.view_style === "list"
                        ? "list-of-shortcut"
                        : "grid-of-shortcut"),
                    on: {
                      click: function($event) {
                        _vm.openModalShortcut(val, index)
                      }
                    }
                  },
                  [
                    _c("img", { attrs: { src: val.icon } }),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(val.title))])
                  ]
                )
              }),
              _vm._v(" "),
              _vm.data_shortcut.view_style === "grid"
                ? _c(
                    "div",
                    {
                      staticClass: "grid-of-shortcut",
                      on: {
                        click: function($event) {
                          _vm.openModalShortcut(null, 0)
                        }
                      }
                    },
                    [
                      _c("img", {
                        staticClass: "btn-add-shortcut",
                        attrs: {
                          src: require("@/assets/icon/shortcut-page/add.svg")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "label-add-shortcut" }, [
                        _vm._v("Add shortcut")
                      ])
                    ]
                  )
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _vm.data_shortcut.view_style === "list"
            ? _c(
                "div",
                {
                  staticClass: "widget-box-configuration_add-shorcut",
                  on: {
                    click: function($event) {
                      _vm.openModalShortcut(null, 0)
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/icon/shortcut-page/add.svg"),
                      width: "11",
                      height: "11"
                    }
                  }),
                  _vm._v("\n      Add shortcut\n    ")
                ]
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("b-col", [
            _c(
              "div",
              { staticClass: "float-to-right" },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "btn gray m__r--5",
                    on: { click: _vm.closeShortcut }
                  },
                  [_vm._v("\n          Close\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "b-button",
                  { staticClass: "btn blue", on: { click: _vm.saveShortcut } },
                  [_vm._v("\n          Save\n        ")]
                )
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "modalShorcut",
          staticClass: "modal-shortcut-page-wrap",
          attrs: {
            "hide-header": true,
            "hide-footer": true,
            "no-close-on-backdrop": "",
            "no-close-on-esc": ""
          }
        },
        [
          _c("div", { staticClass: "modal-shortcut-page" }, [
            _c("div", { staticClass: "modal-shortcut-page__header" }, [
              _c("div", { staticClass: "modal-shortcut-page__header__title" }, [
                _c("img", {
                  attrs: {
                    src: require("@/assets/icon/shortcut-page/add-shortcut.svg"),
                    width: "33",
                    height: "33"
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "title" }, [
                  _vm._v(
                    _vm._s(_vm.mode_form === "create" ? "Add" : "Edit") +
                      " Shortcut"
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticClass: "modal-shortcut-page__header__icon",
                  on: {
                    click: function($event) {
                      _vm.$emit("close")
                    }
                  }
                },
                [_vm._v("\n          ×\n        ")]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal-shortcut-page__content" },
              [
                _c(
                  "div",
                  { staticClass: "widget-box-configuration m__b--10" },
                  [
                    _c(
                      "div",
                      { staticClass: "widget-box-configuration_title" },
                      [_vm._v("Icon")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "widget-box-configuration_desc" },
                      [
                        _vm._v(
                          "\n            Image that represents the shortcut button\n          "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "d-flex" }, [
                      _c(
                        "div",
                        {
                          staticClass: "preview-icon",
                          class: {
                            "error-icon": _vm.$v.item_shortcut.icon_url.$error
                          }
                        },
                        [
                          _vm.item_shortcut.icon_url
                            ? _c("img", {
                                attrs: { src: _vm.item_shortcut.icon_url }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("input", {
                            ref: "iconUpload",
                            staticClass: "upload-photo",
                            attrs: { type: "file" },
                            on: {
                              change: function($event) {
                                _vm.handleIconUpload($event)
                              }
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", [
                        _vm.item_shortcut.icon_url
                          ? _c(
                              "div",
                              { staticClass: "widget-box-configuration_title" },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.item_shortcut.icon_url
                                        .split("/")
                                        .pop()
                                    ) +
                                    "\n              "
                                )
                              ]
                            )
                          : _c(
                              "div",
                              { staticClass: "widget-box-configuration_title" },
                              [_vm._v("\n                None\n              ")]
                            ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "upload-btn",
                            on: {
                              click: function($event) {
                                _vm.$refs.iconUpload.click()
                              }
                            }
                          },
                          [_vm._v("\n                Change\n              ")]
                        )
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "b-form-group",
                  {
                    staticClass: "m__b--10",
                    class: { "error-input": _vm.$v.item_shortcut.title.$error }
                  },
                  [
                    _c("label", [_vm._v(" Title ")]),
                    _vm._v(" "),
                    _c("j-input", {
                      attrs: {
                        "max-length": 255,
                        "error-required": _vm.$v.item_shortcut.title.$error,
                        placeholder: "Title"
                      },
                      model: {
                        value: _vm.$v.item_shortcut.title.$model,
                        callback: function($$v) {
                          _vm.$set(_vm.$v.item_shortcut.title, "$model", $$v)
                        },
                        expression: "$v.item_shortcut.title.$model"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-form-group",
                  {
                    staticClass: "m__b--10",
                    class: {
                      "error-input": _vm.$v.item_shortcut.application.$error
                    }
                  },
                  [
                    _c("label", [_vm._v(" Application ")]),
                    _vm._v(" "),
                    _c("j-single-select", {
                      attrs: {
                        options: _vm.applications_list,
                        "error-required":
                          _vm.$v.item_shortcut.application.$error,
                        label: "name",
                        "value-format": "object",
                        placeholder: "Choose Application"
                      },
                      on: { getData: _vm.getApplicationPages },
                      model: {
                        value: _vm.$v.item_shortcut.application.$model,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.$v.item_shortcut.application,
                            "$model",
                            $$v
                          )
                        },
                        expression: "$v.item_shortcut.application.$model"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-form-group",
                  {
                    staticClass: "m__b--10",
                    class: { "error-input": _vm.$v.item_shortcut.page.$error }
                  },
                  [
                    _c("label", [_vm._v(" Page ")]),
                    _vm._v(" "),
                    _c("j-single-select", {
                      attrs: {
                        options: _vm.list_page,
                        "error-required": _vm.$v.item_shortcut.page.$error,
                        label: "name",
                        "value-format": "object",
                        placeholder: "Choose Page"
                      },
                      model: {
                        value: _vm.$v.item_shortcut.page.$model,
                        callback: function($$v) {
                          _vm.$set(_vm.$v.item_shortcut.page, "$model", $$v)
                        },
                        expression: "$v.item_shortcut.page.$model"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "modal-shortcut-page__footer" }, [
              _c("div", [
                _vm.mode_form === "update"
                  ? _c(
                      "button",
                      {
                        staticClass: "button-red",
                        on: { click: _vm.removeItemShortcut }
                      },
                      [_vm._v("\n            Delete\n          ")]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "d-flex" }, [
                _c(
                  "button",
                  {
                    staticClass: "button-border m__r--10",
                    on: { click: _vm.closeModalShortcut }
                  },
                  [_vm._v("\n            Close\n          ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "button-blue",
                    on: { click: _vm.saveItemShortcut }
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.mode_form === "create" ? "Save" : "Update") +
                        "\n          "
                    )
                  ]
                )
              ])
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-34cc0dc8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34cc0dc8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/widget/widget-component/jShortcutPageSetup.vue
// module id = null
// module chunks = 